var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M7.29167 10.8333C8.3272 10.8333 9.16667 11.6728 9.16667 12.7083V15.625C9.16667 16.6605 8.3272 17.5 7.29167 17.5H4.375C3.33947 17.5 2.5 16.6605 2.5 15.625V12.7083C2.5 11.6728 3.33947 10.8333 4.375 10.8333H7.29167ZM15.625 10.8333C16.6605 10.8333 17.5 11.6728 17.5 12.7083V15.625C17.5 16.6605 16.6605 17.5 15.625 17.5H12.7083C11.6728 17.5 10.8333 16.6605 10.8333 15.625V12.7083C10.8333 11.6728 11.6728 10.8333 12.7083 10.8333H15.625ZM7.29167 2.5C8.3272 2.5 9.16667 3.33947 9.16667 4.375V7.29167C9.16667 8.3272 8.3272 9.16667 7.29167 9.16667H4.375C3.33947 9.16667 2.5 8.3272 2.5 7.29167V4.375C2.5 3.33947 3.33947 2.5 4.375 2.5H7.29167ZM15.625 2.5C16.6605 2.5 17.5 3.33947 17.5 4.375V7.29167C17.5 8.3272 16.6605 9.16667 15.625 9.16667H12.7083C11.6728 9.16667 10.8333 8.3272 10.8333 7.29167V4.375C10.8333 3.33947 11.6728 2.5 12.7083 2.5H15.625Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridFilled);
export default __webpack_public_path__ + "static/media/grid_filled.a368095e58ddf1ca136b5b57c396def0.svg";
export { ForwardRef as ReactComponent };